import httpService from "./httpService";
import utils from "./utils";

export default {
  getAll(keyword, pageable) {
    let params = utils.merge({keyword: keyword}, pageable);
    return httpService.get("meetingRoom/getAll", {params: params});
  },

  create(form) {
    return httpService.post(`/meetingRoom`, form)
  },

  createMobimeetingCoDinh(form) {
    return httpService.post(`/meetingRoom/createMobimeetingCoDinh`, form)
  },

  update(id, form) {
    return httpService.put(`/meetingRoom/${id}`, form)
  },

  delete(id) {
    return httpService.delete("/meetingRoom/" + id);
  }
};



// WEBPACK FOOTER //
// ./src/services/meetingRoomService.js